module.exports = __webpack_public_path__ + "img/tzjk_sel.e6593edb.svg";